import React from "react";
import Header from "../Header";
import { Link } from "react-router-dom";
import Footer from "../Footer";
import "./video.css";
import { Helmet } from "react-helmet";


const Video = (props) => {
  return (
    <>
      <Helmet>
        <title>Ramapir | Videos</title>
        <meta name="keywords" content=" બાબા રામદેવ જી ભારતમાં રાજસ્થાનના લોક-દેવતા છે. તેઓ 14મી સીના સંત હતા, જેમણે પોતાનું જીવન દલિત લોકોના ઉત્થાન માટે સમર્પિત કર્યું હતું. જ્યારે હિંદુઓ તેમને ભગવાન કૃષ્ણના અવતાર માને છે, મુસ્લિમો તેમને રામશાહ પીર અથવા રામા શાહ પીર તરીકે પૂજે છે. તેમની પાસે ચમત્કારિક શક્તિઓ હોવાનું કહેવાય છે, અને તેમની ખ્યાતિ દૂર દૂર સુધી પહોંચી હતી. દંતકથા કહે છે કે મક્કાથી પાંચ પીર રામદેવની શક્તિઓનું પરીક્ષણ કરવા આવ્યા હતા. રામદેવે પ્રારંભિક સ્વાગત કર્યાં બાદ તેમને તેમની સાથે લંચ કરવા વિનંતી કરી. પરંતુ પીરોએ આગ્રહ કર્યો કે તેઓ તેમના અંગત વાસણોમાં ખાય છે, મક્કામાં પડેલા છે, તેથી તેઓ તેમનું ભોજન કરી શકે છે. આના પર રામદેવ હસ્યા અને કહ્યું, જુઓ તમારા વાસણો આવી રહ્યા છે, અને તેઓએ જોયું કે તેમના ખાવાના વાસણો મક્કાથી હવામાં ઉડતા હતા. તેમની ક્ષમતાઓ અને શક્તિઓની ખાતરી થયા પછી, તેઓએ તેમને શ્રદ્ધાંજલિ આપી અને તેમનું નામ રામા શાહ પીર રાખ્યું. તેમની શક્તિઓનું પરીક્ષણ કરવા આવેલા પાંચ પીર તેમની શક્તિઓથી એટલા પ્રભાવિત થયા કે તેઓએ તેમની સાથે રહેવાનું નક્કી કર્યું અને આજે આ પાંચેયની સમાધિઓ પણ રામદેવની સમાધિ પાસે છે.
                        રાજસ્થાનમાં, રામદેવ મેઘવાલ સમુદાયના મુખ્ય દેવતા છે, જેની પૂજા વેદવા પુનમ (ઑગસ્ટ - સપ્ટેમ્બર) દરમિયાન કરવામાં આવે છે." />
      </Helmet>

      <Header />
      <div
        data-elementor-type="cpt_layouts"
        data-elementor-id="46"
        className="elementor elementor-46"
      >
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-52ebb12  elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="52ebb12"
          data-element_type="section"
          data-settings='{"background_background":"classic"}'
          style={{ height: "30rem", marginBottom: "5rem" }}
        >
          <div className="elementor-background-overlay"></div>
          <div className="elementor-container elementor-column-gap-extended">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ae9d67e sc_inner_width_none sc_layouts_column_icons_position_left"
              data-id="ae9d67e"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <section
                  className="elementor-section elementor-inner-section elementor-element elementor-element-fcf91b3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="fcf91b3"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-93dfaf4 sc_inner_width_none sc_layouts_column_icons_position_left"
                      data-id="93dfaf4"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="sc_layouts_item elementor-element elementor-element-847c2c5 sc_fly_static elementor-widget elementor-widget-spacer"
                          data-id="847c2c5"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                          style={{ height: "8rem" }}
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner"></div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="sc_layouts_item elementor-element elementor-element-8fe49e3 sc_fly_static elementor-widget elementor-widget-trx_sc_layouts_title"
                          data-id="8fe49e3"
                          data-element_type="widget"
                          data-widget_type="trx_sc_layouts_title.default"
                        >
                          <div className="elementor-widget-container">
                            <div
                              id="trx_sc_layouts_title_515615674"
                              className="sc_layouts_title sc_align_center with_content without_image without_tint"
                            >
                              <div className="sc_layouts_title_content">
                                <div className="sc_layouts_title_title">
                                  {" "}
                                  {/* <h1 className="sc_layouts_title_caption">
                                    Video
                                  </h1> */}
                                </div>
                                <div className="sc_layouts_title_breadcrumbs">
                                  <div className="breadcrumbs">

                                    {/* <span className="breadcrumbs_item current">
                                      Videos
                                    </span> */}
                                  </div>
                                </div>
                              </div>
                            </div>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>
      <>
        <div>
          <h5 className="video">Videos</h5>
        </div>
        <div className="page_content_wrap ">
          <div className="content_wrap">
            <div className="content">
              <div className="posts_container columns_wrap columns_padding_bottom">
                <div className="column-1_2">
                  <article
                    id="post-686"
                    className="post_item post_format_standard post_layout_classic post_layout_classic_2 post-686 post type-post status-publish format-standard has-post-thumbnail hentry category-news"
                  >
                    <div className="post_featured with_thumb hover_icon">
                      <iframe
                        width={560}
                        height={315}
                        src="https://www.youtube.com/embed/HbMfUGibUa4?si=P3WC3fzP1I15XIZW"
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      />
                      <div className="mask" />
                    </div>{" "}
                    <div className="post_header entry-header">
                      <h4 className="post_title entry-title">
                        <Link to={'https://www.youtube.com/embed/HbMfUGibUa4?si=P3WC3fzP1I15XIZW'} rel="bookmark" target="_blank" className="v-title">Ramdev pir ni Aarti</Link>
                      </h4>
                    </div>
                    <div className="post_content entry-content">
                      <div className="post_content_inner">
                       
                      </div>{" "}
                    </div>
                  </article>
                </div>
                <div className="column-1_2">
                  <article
                    id="post-120"
                    className="post_item post_format_standard post_layout_classic post_layout_classic_2 post-120 post type-post status-publish format-standard has-post-thumbnail hentry category-news tag-mantra tag-practice tag-yoga"
                  >
                    <div className="post_featured with_thumb hover_icon">
                      <iframe
                        width={560}
                        height={315}
                        src="https://www.youtube.com/embed/oIdI9WF92Yc?si=QNBXlH0Uil5UG_6B"
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      />

                      <div className="mask" />
                    </div>{" "}
                    <div className="post_header entry-header">
                      <h4 className="post_title entry-title">
                        <Link to={'https://www.youtube.com/embed/oIdI9WF92Yc?si=QNBXlH0Uil5UG_6B'} rel="bookmark" className="v-title" target="_blank">Ramdev pir nonstop bhajan</Link>
                      </h4>{" "}

                    </div>
                    <div className="post_content entry-content">
                      <div className="post_content_inner">
                       
                      </div>{" "}
                    </div>
                  </article>
                </div>
                <div className="column-1_2">
                  <article
                    id="post-144"
                    className="post_item post_format_standard post_layout_classic post_layout_classic_2 post-144 post type-post status-publish format-standard has-post-thumbnail hentry category-news tag-mantra tag-practice tag-yoga"
                  >
                    <div className="post_featured with_thumb hover_icon">
                      <iframe
                        className="video-content"
                        width={370}
                        height={208}
                        src="https://www.youtube.com/embed/b3u90OC8jOk?si=g_ufjVcQT73FLHLD"
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      />
                      <div className="mask" />
                    </div>{" "}
                    <div className="post_header entry-header">
                      <h4 className="post_title entry-title">
                        <Link to={'https://www.youtube.com/embed/b3u90OC8jOk?si=g_ufjVcQT73FLHLD'} rel="bookmark" target="_blank" className="v-title">Ramdevpir No Rankar </Link>
                      </h4>{" "}
                    </div>
                    <div className="post_content entry-content">
                      <div className="post_content_inner">
                       
                      </div>{" "}
                    </div>
                  </article>
                </div>
                <div className="column-1_2">
                  <article
                    id="post-146"
                    className="post_item post_format_standard post_layout_classic post_layout_classic_2 post-146 post type-post status-publish format-standard has-post-thumbnail hentry category-news tag-mantra tag-practice tag-yoga"
                  >
                    <div className="post_featured with_thumb hover_icon">
                      <iframe
                        width={560}
                        height={315}
                        src="https://www.youtube.com/embed/1q0S1gnzKu4?si=j7AaUeeOAYYy6OzU"
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      />
                      <div className="mask" />
                    </div>{" "}
                    <div className="post_header entry-header">
                      <h4 className="post_title entry-title">
                        <Link to={'https://www.youtube.com/embed/1q0S1gnzKu4?si=j7AaUeeOAYYy6OzU'} rel="bookmark" target="_blank" className="v-title">Lila Pila Neja Farke</Link>
                      </h4>{" "}

                    </div>
                    <div className="post_content entry-content">
                      <div className="post_content_inner">
                       
                      </div>{" "}
                    </div>
                  </article>
                </div>
                <div
                  className="column-1_2">
                  <article
                    id="post-142"
                    className="post_item post_format_standard post_layout_classic post_layout_classic_2 post-142 post type-post status-publish format-standard has-post-thumbnail hentry category-news tag-mantra tag-practice tag-yoga"
                  >
                    <div className="post_featured with_thumb hover_icon">
                      <iframe
                        width={560}
                        height={315}
                        src="https://www.youtube.com/embed/uXVbUcZ4I7o?si=HrQyBQ5sB_WCdj4m"
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      />

                      <div className="mask" />
                    </div>{" "}
                    <div className="post_header entry-header">
                      <h4 className="post_title entry-title">
                        <Link to={'https://www.youtube.com/embed/uXVbUcZ4I7o?si=HrQyBQ5sB_WCdj4m'} rel="bookmark" target="_blank" className="v-title">Ramapir Movie</Link>
                      </h4>{" "}
                    </div>
                    <div className="post_content entry-content">
                      <div className="post_content_inner">
                       
                      </div>{" "}
                    </div>
                  </article>
                </div>
                <div
                  className="column-1_2"
                >
                  <article
                    id="post-148"
                    className="post_item post_format_standard post_layout_classic post_layout_classic_2 post-148 post type-post status-publish format-standard has-post-thumbnail hentry category-news tag-mantra tag-practice tag-yoga"
                  >
                    <div className="post_featured with_thumb hover_icon">
                      <iframe
                        width={560}
                        height={315}
                        src="https://www.youtube.com/embed/5Q3JJfQVG0s?si=7yrWOHcBskCjKen_"
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      />

                      <div className="mask" />
                    </div>{" "}
                    <div className="post_header entry-header">
                      <h4 className="post_title entry-title">
                        <Link to={'https://www.youtube.com/embed/5Q3JJfQVG0s?si=7yrWOHcBskCjKen'} rel="bookmark" target="_blank" className="v-title">Dhup Ne Dhumade Vela Aavjo</Link>

                      </h4>{" "}

                    </div>
                    <div className="post_content entry-content">
                      <div className="post_content_inner">
                       
                      </div>{" "}
                    </div>
                  </article>
                </div>
                <div
                  className="
column-1_2"
                >
                  <article
                    id="post-151"
                    className="post_item post_format_standard post_layout_classic post_layout_classic_2 post-151 post type-post status-publish format-standard has-post-thumbnail hentry category-news tag-mantra tag-practice tag-yoga"
                  >
                    <div className="post_featured with_thumb hover_icon">
                      <iframe
                        className="video-content"
                        width={370}
                        height={208}
                        src="https://www.youtube.com/embed/rGulqk34O1Y?si=6lLSfPbehO6Hb_H-"
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      />
                      <div className="mask" />
                    </div>{" "}
                    <div className="post_header entry-header">
                      <h4 className="post_title entry-title">
                        <Link to={'https://www.youtube.com/embed/rGulqk34O1Y?si=6lLSfPbehO6Hb_H-'} rel="bookmark" target="_blank" className="v-title">Ramdev Ni Kankotri</Link>
                      </h4>{" "}
                    </div>
                    <div className="post_content entry-content">
                      <div className="post_content_inner">
                       
                      </div>{" "}
                    </div>
                  </article>
                </div>
                <div
                  className="
column-1_2"
                >
                  <article
                    id="post-154"
                    className="post_item post_format_standard post_layout_classic post_layout_classic_2 post-154 post type-post status-publish format-standard has-post-thumbnail hentry category-news tag-mantra tag-practice tag-yoga"
                  >
                    <div className="post_featured with_thumb hover_icon">
                      <iframe
                        className="video-content"
                        width={370}
                        height={208}
                        src="https://www.youtube.com/embed/EgUqk5bqREU?si=RI5J7Zbu8lQPNPL9"
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      />
                      <div className="mask" />
                    </div>{" "}
                    <div className="post_header entry-header">
                      <h4 className="post_title entry-title">
                        <Link to={'https://www.youtube.com/embed/EgUqk5bqREU?si=RI5J7Zbu8lQPNPL9'} rel="bookmark" target="_blank" className="v-title">Ramdevpir Dayro</Link>
                      </h4>{" "}

                    </div>
                    <div className="post_content entry-content">
                      <div className="post_content_inner">
                      
                      </div>{" "}
                    </div>
                  </article>
                </div>{" "}
              </div>
            </div>
            <div className="clearfix" />
          </div>
        </div>
      </>

      <div>
        {/* <AudioPlayer state={props.state} onPlay={(isPlay) => this.setState({ isPlay }) } /> */}
        <Footer />
      </div>
    </>
  );
};

export default Video;